import {
  GET_TYPE_NOTES,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
  CREATE_TYPE_NOTES,
  UPDATE_TYPE_NOTES,
  DELETE_TYPE_NOTES
} from "./actionType";

// common success
export const TypeNotesApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const TypeNotesApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const GetTypeNotes = () => ({
  type: GET_TYPE_NOTES,
});

export const CreateTypeNotes = (data) => ({
  type: CREATE_TYPE_NOTES,
  payload: { data },
});

export const UpdateTypeNotes = (data) => ({
  type: UPDATE_TYPE_NOTES,
  payload: { data },
});

export const DeleteTypesNotes = (id) => ({
	type: DELETE_TYPE_NOTES,
	payload: { id },
  });
  